export default __webpack_public_path__ + "static/media/2.48f0eb26.png";